module.exports = __webpack_public_path__ + "img/gepres-blogs-mini.c3745b87.svg";